import React from 'react';

export default function Placeholders() {
  return (
    <>
      <p>Title and Text can have placeholders: enterprise_name</p>
      <p>
        {
        `Example: Describe company
        %{enterprise_name}`
        }
      </p>
    </>
  );
}
